import {request} from './repository';

const url = 'source-services/';


const sourceServiceRepository = {
    getSourceServices(params) {
        return request.get(url, params);
    },
    getAllSourceServices() {
        return request.get('available-source-services');
    },
    getAnonymousSourceServices(params = null) {
        return request.get('all-anonymous-source-services', params);
    },
    getSourceServicesForMultipleExecution(params = null) {
        return request.get('multiple/source-services', params);
    },
    showSourceService(id) {
        return request.get(url + id);
    },
    getSourceProcedures(id) {
        return request.get(url + id + '/source-procedures');
    },
    storeSourceService(data) {
        let form = {
            name: data.name,
            description: data.description,
            enabled: data.enabled,
            enable_concurrent_services: data.enable_concurrent_services,
            visibility: data.visibility,
            source_service_category_id: data.source_service_category.id,
            source_service_type_id: data.source_service_type.id,
            source_service_priority_id: data.source_service_priority.id,
            visible_mobile: data.visible_mobile,
            visible_web: data.visible_web,
            visible_admin: data.visible_admin,
            address_required: data.address_required,
            roles: data.roles
        }
        return request.post(url, form);
    },
    updateSourceService(id, data) {
        let form = {
            name: data.name,
            description: data.description,
            enabled: data.enabled,
            enable_concurrent_services: data.enable_concurrent_services,
            visibility: data.visibility,
            source_service_category_id: data.source_service_category.id,
            source_service_type_id: data.source_service_type.id,
            source_service_priority_id: data.source_service_priority.id,
            visible_mobile: data.visible_mobile,
            visible_web: data.visible_web,
            visible_admin: data.visible_admin,
            address_required: data.address_required,
            internal_service: data.internal_service,
            roles: data.roles
        }
        return request.put(url + id, form);
    },
    fetchVisibilityTypes() {
        return request.get('source-services-visibility-types');
    },
    toggleStatus(id) {
        return request.put(url + id + '/toggle-status', null);
    }
}

export default sourceServiceRepository
